import React from 'react';
import {
    Sheet,
    SheetContent,
    SheetTrigger,
} from "../ui/sheet";
import { Button } from "../ui/button";
import { Menu } from "lucide-react";
import FolderSidebar from './FolderSidebar';

export default function MobileDrawer({
    folders,
    alertCounts,
    selectedFolder,
    onSelectFolder,
    onToggleFollow,
    isLoading,
    open,
    onOpenChange
}) {
    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    className="lg:hidden text-slate-400 hover:text-white hover:bg-slate-800"
                >
                    <Menu className="h-5 w-5" />
                </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-80 p-0 bg-slate-950 border-slate-800">
                <FolderSidebar
                    folders={folders}
                    alertCounts={alertCounts}
                    selectedFolder={selectedFolder}
                    onSelectFolder={(folder) => {
                        onSelectFolder(folder);
                        onOpenChange(false);
                    }}
                    onToggleFollow={onToggleFollow}
                    isLoading={isLoading}
                />
            </SheetContent>
        </Sheet>
    );
}
